module.exports = __webpack_public_path__ + "media/images/lp/1/description1-pc-07262c286f88948c32e6f3fb42d4d05e.jpg";